import { formatWithTimezone } from 'src/libs/util'
import React from 'react'
import useGetWithContext from 'src/hooks/useGetWithContext'
import { UsernameById1 } from './UsernameById'

export function SimpleNotes ({ notes, removeTime, isBreak, isHtmlComment }) {
  const replaceWithBr = (comment) => {
    return comment.replace(/\n/g, '<br />')
  }

  if (!notes?.length) return null

  const noteList = notes.map((note, idx) => {
    const { userId, comment, time, color: textColor } = note
    let noteColor = ''
    if (textColor === 'RED') noteColor = 'text-danger'
    if (!comment || !userId) return null
    const user = <UsernameById1 useHook={useGetWithContext} id={userId} />
    return (
      <React.Fragment key={idx}>
        <div className='simple-note-item mb-2' style={{ textAlign: 'justify' }}>
          <span className='text-secondary' style={{ whiteSpace: 'nowrap' }}>
            {user}{': '}
            {!removeTime && time
              ? `${formatWithTimezone(time, 'HH:mm dd/MM/yyyy')}`
              : null}<br />
          </span>
          {isHtmlComment ? <span className={noteColor} dangerouslySetInnerHTML={{ __html: replaceWithBr(comment) }} /> : <span className={noteColor}>{comment}</span>}
        </div>
        {isBreak && <br />}
      </React.Fragment>
    )
  })
  return <>{noteList}</>
}
